
<template>
    <div>
        <dailywork-form ref="dailyworkForm"></dailywork-form>
        <b-row>
                <b-col class="col-lg-2">
                    <label for="cost-accounting-matter-no-input"> {{ $t('costAccounting.matter_no') }} </label>
                    <b-form-input id="cost-accounting-matter-no-input" size="sm" v-model="matterNo" v-on:keyup.enter="GetCostAccountingReportList()" :placeholder="$t('costAccounting.matter_no')" type="text" class="d-inline-block mr-1" />
                </b-col>
                <b-col class="col-lg-2">
                    <label for="cost-accounting-vendor-input"> {{ $t('costAccounting.vendor') }} </label>
                    <b-form-select id="cost-accounting-vendor-input" size="sm" v-model="vendorSelect" value-field="code" text-field="name" :options="vendorOption" />
                </b-col>
                <b-col class="col-lg-2">
                    <label for="cost-accounting-expense-input"> {{ $t('costAccounting.expense') }} </label>
                    <b-form-select id="cost-accounting-expense-input" size="sm" v-model="expenseSelect" value-field="code" text-field="name" :options="expenseOption" />
                </b-col>

                <b-col class="col-lg-2">
                    <b-card-text class="mb-0" for="cost-accounting-posted-input"> {{ $t('costAccounting.posted') }} </b-card-text>
                    <b-form-checkbox class="custom-control-success" id="cost-accounting-posted-input" v-model="posted" switch>
                      <span class="switch-icon-left">
                          <feather-icon icon="CheckIcon" />
                      </span>
                      <span class="switch-icon-right">
                          <feather-icon icon="XIcon" />
                      </span>
                    </b-form-checkbox>
                </b-col>   

            <b-col class="d-flex justify-content-end col-lg-4">
                <b-button style="float:right;" class="mr-1 mt-2" size="sm" variant="outline-primary" @click="GetCostAccountingReportList()" v-on:keyup.enter="GetCostAccountingReportList()">{{ $t('costAccounting.list') }}</b-button>
               <!--<b-button style="float:right;" class="mr-1 mt-2" size="sm" variant="outline-primary" @click="getSelfEmploymentInfo(0)">{{ $t('costAccounting.self_employment') }}</b-button> -->
                <b-button style="float:right; border-color:#6B7280; color:#374151;" class="mt-2" size="sm" variant="outline-secondary" @click="exportExcel()">{{ $t('costAccounting.excel') }}</b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="col-lg-2 mt-1">
                <label for="cost-accounting-start-amount-input"> {{ $t('costAccounting.start_amount') }} </label>
                <b-form-input id="cost-accounting-start-amount-input" size="sm" v-model="startAmount" v-on:keyup.enter="GetCostAccountingReportList()" :placeholder="$t('costAccounting.start_amount')" type="text" class="d-inline-block" />
            </b-col>
            <b-col class="col-lg-2 mt-1">
                <label for="cost-accounting-end-amount-input"> {{ $t('costAccounting.end_amount') }} </label>
                <b-form-input id="cost-accounting-end-amount-input" size="sm" v-model="endAmount" v-on:keyup.enter="GetCostAccountingReportList()" :placeholder="$t('costAccounting.end_amount')" type="text" class="d-inline-block" />
            </b-col>
            <b-col class="col-lg-2 mt-1">
                <label for="cost-accounting-start-document-date-input"> {{ $t('costAccounting.start_document_date') }} </label>
                <b-form-datepicker id="cost-accounting-start-document-date-input" today-button :label-today-button="$t('dateTime.today')" :placeholder="$t('costAccounting.start_document_date')" size="sm" v-model="startDocumentDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
            </b-col>
            <b-col class="col-lg-2 mt-1">
                <label for="cost-accounting-end-document-date-input"> {{ $t('costAccounting.end_document_date') }} </label>
                <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" :placeholder="$t('costAccounting.end_document_date')" size="sm" v-model="endDocumentDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
            </b-col>               
        </b-row>
        <!-- table -->
        <vue-good-table class="mt-1" id="costAccountingTable" ref="costAccountingTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :search-options="{
            enabled: true,
            externalQuery: searchTerm
          }" :select-options="{
            enabled: false,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
            selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
          }" :pagination-options="{
            enabled: true,
            perPage: pageLength
          }" theme="my-theme">
            <div slot="emptystate">
                {{ $t('dataTable.data_not_found') }}
            </div>
            <!-- Row: Table Row -->
            <template slot="table-column" slot-scope="props">
                <span v-if="props.column.field === 'matterNo'" class="text-nowrap">
                    {{ $t('costAccounting.matter_no') }}
                </span>
                <span v-else-if="props.column.field === 'taskExpense'" class="text-nowrap">
                    {{ $t('costAccounting.task_expense') }}
                </span>
                <span v-else-if="props.column.field === 'agentClientName'" class="text-nowrap">
                    {{ $t('costAccounting.agent_client_name') }}
                </span>
                <span v-else-if="props.column.field === 'documentDate'" class="text-nowrap">
                    {{ $t('costAccounting.document_date') }}
                </span>
                <span v-else-if="props.column.field === 'userName'" class="text-nowrap">
                    {{ $t('costAccounting.user_name') }}
                </span>
                <span v-else-if="props.column.field === 'amountWitholdingTax'" class="text-nowrap">
                    {{ $t('costAccounting.amount_witholding_tax') }}
                </span>
                <span v-else-if="props.column.field === 'vatAmount'" class="text-nowrap">
                    {{ $t('costAccounting.vat_amount') }}
                </span>
                <span v-else-if="props.column.field === 'accountingDescription'" class="text-nowrap">
                    {{ $t('costAccounting.accounting_description') }}
                </span>
                <span v-else-if="props.column.field === 'process'" class="text-nowrap"></span>
            </template>

            <template slot="table-row" slot-scope="props">
                <!-- Column: Process -->
                <span v-if="props.column.field === 'expenseCode'">
                    <span >
                        {{ props.row.vendorCode }}
                    </span>
                    <br>
                    <span>
                        {{ props.row.serviceAccountingNumber }}
                    </span>
                    <br>
                    <span >
                        {{ props.row.expenseCode }}
                    </span>

                </span>
                <span v-else-if="props.column.field === 'agentClientName'">
                    <span>
                        {{props.row.clientName }}
                    </span>
                    <br>
                    <span >
                        {{props.row.agent }}
                    </span>
                </span>
                <span v-else-if="props.column.field === 'documentDate'">
                    <span>
                        {{ $formatFn(props.row.documentDate) }}
                    </span>
                    <br>
                    <span>
                        {{ $formatFn(props.row.date) }}
                    </span>
                </span>
                <span v-else-if="props.column.field === 'amount'">
                    <span>
                        {{ $formatMoneyTr(props.row.amount) }}
                    </span>
                    <br>
                    <span>
                        {{ $formatMoneyTr(props.row.withholdingTax) }}
                    </span>
                </span>
                <span v-else-if="props.column.field === 'vat'">
                    <span>
                        {{ '% ' + $formatMoneyTr(props.row.vat) + ' ' + $formatMoneyTr(props.row.vatAmount) }}
                    </span>
                </span>
                <span v-else-if="props.column.field === 'accountingDescription'">
                    <div v-b-tooltip.hover="{ title: props.row.accountingDescription, customClass: 'wh-tooltip' }" class="wh-clamp-2">{{ props.row.accountingDescription }}</div>
                </span>
                <span v-else-if="props.column.field === 'process'">
                    <list-actions-dropdown :actions="[
                        { icon: 'EditIcon', label: $t('others.edit'), handler: () => openDailyworkForm(props.row) },
                        { icon: 'CheckIcon', label: $t('others.Transfer'), color: '#2563EB', show: props.row.isTransfer == false, handler: () => getCostAccountingInfo(props.row) }
                    ]" />
                </span>
            </template>
    
            <!-- pagination -->
            <template slot="pagination-bottom" slot-scope="props">
                <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ total }} {{ $t('dataTable.record') }}</span>
                        <b-form-select size="sm" v-model="pageLength" :options="['10','25','50','100']" class="mx-1" @input="(value)=>props.perPageChanged({currentPerPage:value})" />
                        <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                    </div>
                    <div>
                        <b-pagination :value="1" :total-rows="total" v-model="pageNo" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => GetCostAccountingReportList()">
                            <template #prev-text>
                                <feather-icon icon="ChevronLeftIcon" size="18" />
                            </template>
                            <template #next-text>
                                <feather-icon icon="ChevronRightIcon" size="18" />
                            </template>
                        </b-pagination>
                    </div>
                </div>
            </template>
        </vue-good-table>
    </div>
    </template>
    
      
    <script>
import { props } from 'vue-prism-component';

    export default {
        data() {
            return {
                dir: false,
                pageLength: 50,
                total : 0,
                pageNo: 1,
                searchDebounce: null,
                requestSeq: 0,
                matterNo: '',
                vendorSelect: '0',
                vendorOption: [],
                expenseSelect: '0',
                expenseOption: [],
                posted: false,
                startAmount: 0,
                endAmount: 0, 
                startDocumentDate: '',
                endDocumentDate: '',
                columns: [{
                        label: this.$t('costAccounting.matter_no'),
                        field: `matterNo`,
                    },
                    {
                        label: this.$t('costAccounting.task_expense'),
                        field: `expenseCode`,
                        width: '10em'
                    },
                    {
                        label: this.$t('costAccounting.agent_client_name'),
                        field: `agentClientName`,
                    },
                    {
                        label: this.$t('costAccounting.document_date'),
                        field: `documentDate`,
                    },
                    {
                        label: this.$t('costAccounting.user_name'),
                        field: `userName`,
                    },
                    {
                        label: this.$t('costAccounting.amount_witholding_tax'),
                        field: `amount`,
                        tdClass: 'text-right',
                        thClass: 'text-right'
                    },
                    {
                        label: this.$t('costAccounting.vat_amount'),
                        field: `vat`,
                        tdClass: 'text-right',
                        thClass: 'text-right'
                    },
                    {
                        label: this.$t('costAccounting.accounting_description'),
                        field: `accountingDescription`,
                    },
                    {
                        label: '',
                        field: 'process',
                        width: '8em',
                        sortable: false
                    },
                ],
                // Ekrandaki kolonlar birleşik gösterildiği için excel'de her alan ayrı kolon olarak verilir.
                excelColumns: [
                    { label: this.$t('costAccounting.matter_no'), field: 'matterNo' },
                    { label: this.$t('costAccounting.vendor'), field: 'vendorCode' },
                    { label: this.$t('costAccounting.accounting_no'), field: 'serviceAccountingNumber' },
                    { label: this.$t('costAccounting.task_expense'), field: 'expenseCode' },
                    { label: this.$t('costAccounting.client_name'), field: 'clientName' },
                    { label: this.$t('costAccounting.agent'), field: 'agent' },
                    { label: this.$t('costAccounting.document_no'), field: 'documentNo' },
                    { label: this.$t('costAccounting.document_date'), field: 'documentDate' },
                    { label: this.$t('costAccounting.record_date'), field: 'date' },
                    { label: this.$t('costAccounting.user_name'), field: 'userName' },
                    { label: this.$t('costAccounting.amount'), field: 'amount' },
                    { label: this.$t('costAccounting.withholding_tax'), field: 'withholdingTax' },
                    { label: this.$t('costAccounting.vat'), field: 'vat' },
                    { label: this.$t('costAccounting.vat_amount'), field: 'vatAmount' },
                    { label: this.$t('costAccounting.accounting_description'), field: 'accountingDescription' },
                ],
                rows: [],
                searchTerm: '',
            }
        },
        mounted() {
            this.startDocumentDate = new Date();
            this.endDocumentDate = new Date();
            this.GetCostAccountingReportList()
        },
        watch: {
            matterNo() { this.debouncedSearch() },
            startAmount() { this.debouncedSearch() },
            endAmount() { this.debouncedSearch() }
        },
        methods: {
            debouncedSearch() {
                clearTimeout(this.searchDebounce)
                this.searchDebounce = setTimeout(() => {
                    this.pageNo = 1
                    this.GetCostAccountingReportList()
                }, 300)
            },
            openDailyworkForm(row){
                this.$refs.dailyworkForm.showInfo(row.id, row.recordId, row.matterNo,row.shortName)
            },
            GetCostAccountingReportList() {
                const requestSeq = ++this.requestSeq
                const controller = { name: 'LawReport', actionName: 'GetCostAccountingReportList' }
                const data = { pageLength: this.pageLength, pageNo: this.pageNo, matterNo: this.matterNo, vendorCode: this.vendorSelect.toString(), expenseCode: this.expenseSelect.toString(), 
                isSend: this.posted, minAmount: this.startAmount, maxAmount: this.endAmount, startDate: this.startDocumentDate, endDate: this.endDocumentDate }
                const payload = { controller: controller, data : data }
                
                let loader = this.$loading.show()
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    // Daha yeni bir istek gonderildiyse bu yanit bayattir, uygulanmaz
                    if (requestSeq !== this.requestSeq) { loader.hide(); return }
                    if (response.data.resultStatus == true) {
                        this.total = response.data.total
                        this.vendorOption = response.data.vendorList
                        this.vendorOption.splice(0, 0, this.$nullSelectedByNames("code","name"))
                        this.expenseOption = response.data.expenseList
                        this.expenseOption.splice(0, 0, this.$nullSelectedByNames("code","name"))
                        this.rows = response.data.lawCostAccountingReportList
                    } else {
                        this.$WarningAlert(response.data.resultMessage)
                    } 
                    loader.hide()         
                })
            },
            getCostAccountingInfo(row) {
                if(row.vendorCode == null)
                {
                    this.$WarningAlert(this.$t("alerts.vendorCodeIsNotSelected"))                    
                    return
                }
                this.$PrivateConfirm(this.$t("costAccounting.confirmTitle"), this.$t("costAccounting.confirmMessage"), "warning", this.$t("costAccounting.confirmButtonText"), this.$t("costAccounting.cancelButtonText")).then(result => {
                    if (result.value) {

                        const data = {
                            lawCostAccounting: row,
                            employeeId: localStorage.getItem('EmployeeId')
                        }
                        const controller = {
                            name: 'AccountingTransaction',
                            actionName: 'CostAccountingTransfer'
                        }
                        const payload = {
                            data: data,
                            controller: controller
                        }

                        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                            if (response.data.resultStatus == true) {
                                this.getEInvoiceAwaitingApprovalList()
                                this.$SaveAlert()
                            } else {
                                this.$WarningAlert(response.data.resultMessage)
                            }
                        })
                    }
                })
            },
            exportExcel() {
                if (this.total == 0) {
                    this.$WarningAlert(this.$t('dataTable.data_not_found'))
                    return
                }
                // Sayfalamadan bağımsız olarak filtreye uyan tüm kayıtlar aktarılır.
                const controller = { name: 'LawReport', actionName: 'GetCostAccountingReportListAsExcel'}
                const data = { columnList: this.excelColumns, matterNo: this.matterNo, vendorCode: this.vendorSelect.toString(), expenseCode: this.expenseSelect.toString(),
                isSend: this.posted, minAmount: this.startAmount, maxAmount: this.endAmount, startDate: this.startDocumentDate, endDate: this.endDocumentDate }
                const payload = { data : data, controller: controller}
                let loader = this.$loading.show()
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    if (response.data.resultStatus == true) {
                        this.$downloadFile("CostAccounting", response.data.base64, 'xlsx')
                    }
                    else {
                        this.$WarningAlert(response.data.resultMessage)
                    }
                    loader.hide()
                }).catch((error) => {
                    loader.hide()
                    this.$WarningAlert(error.response ? error.response.data.resultMessage : error.message)
                })
            }
        },
    }
    </script>
      
    <style lang="scss">
    .tableSize {
        font-size: 13px !important;
        border-collapse: collapse;
        width: 100%;
        max-width: 100%;
        table-layout: auto;
    }
    </style>
    